import { render } from "./QueueEntryView.vue?vue&type=template&id=67105c0a&scoped=true&ts=true"
import script from "./QueueEntryView.vue?vue&type=script&lang=ts"
export * from "./QueueEntryView.vue?vue&type=script&lang=ts"

import "./QueueEntryView.vue?vue&type=style&index=0&id=67105c0a&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67105c0a"]])

export default __exports__